import IUserLogin from "../models/account/IUserLogin";
import { IAuctionInfo } from "../models/auction/IAuctionInfo";
import { IParcelDetail } from "../models/parcel/IParcelDetail";
import * as Roles from "../models/security/Roles";
import { RoleType } from "../models/security/Roles";

export type PermissionType = (user: IUserLogin | null) => boolean;

export const userHasRole =
    (expectedRole: RoleType) => (user: IUserLogin | null) => {
        return !!user && !!user.roles && user.roles.indexOf(expectedRole) > -1;
    };

export default class SecurityProvider {
    public static AnonymousAccess: PermissionType = () => true;
    public static CanSeeAdminLink: PermissionType = userHasRole(
        Roles.Administrator
    );
    public static CanManageAuctionsAndParcels: PermissionType = userHasRole(
        Roles.Administrator
    );
    public static CanManageUsers: PermissionType = userHasRole(
        Roles.Administrator
    );
    public static CanPlaceBids: PermissionType = userHasRole(Roles.Bidder);

    public static CanPlaceBidOnParcel = (
        user: IUserLogin,
        parcel: IParcelDetail,
        auctionInfo: IAuctionInfo
    ) =>
        SecurityProvider.CanPlaceBids(user) &&
        (!parcel.enBloc || parcel.isApprovedEnBlocBidder === true) &&
        auctionInfo.isApprovedAuctionBidder;

    public static CanDebug: PermissionType = userHasRole(Roles.Developer);
}
